<script setup>
import {ref, computed, useAttrs, useSlots} from "vue";
import EditToggleButton from "../Pub/components/EditToggleButton.vue";
import { usePortalContentAndDesignStore } from "../../../stores/partners/portalContentAndDesignStore";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const props = defineProps({
    label: {
        type: String,
        required: true
    },
    url: {
        type: String,
        required: true
    },
    linkTarget: {
        type: String,
        default: "_self"
    },
    linkClasses: {
        type: [String, Array],
        default: ""
    },
});

const emit = defineEmits(["update:label", "update:url"]);

const linkLabel = computed({
    get: () => props.label,
    set: (val) => emit("update:label", val)
});

const linkRoute = computed({
    get: () => props.url,
    set: (val) => emit("update:url", val)
});

const isEditing = ref(false);
const hoverActive = ref(false);
const slots = useSlots();

const toggleEdit = () => {
    isEditing.value = !isEditing.value;
    if (!isEditing.value) {
        hoverActive.value = false;
    }
};

</script>

<template>
    <div
        class="relative"
        @mouseenter="hoverActive = true"
        @mouseleave="hoverActive = false"
    >
        <edit-toggle-button
            v-show="portalContentAndDesignStore.liveDesignerEnabled && (isEditing || hoverActive)"
            :is-editing="isEditing"
            @toggle="toggleEdit"
            class="transition-opacity duration-200"
        />

        <a
            v-if="linkLabel && linkRoute && !isEditing"
            :href="linkRoute"
            :target="linkTarget"
            class="hover:underline text-opacity-100"
            :class="linkClasses"
        >
            <template v-if="slots['custom-content']">
                <slot name="custom-content" />
            </template>
            <template v-else>
                {{ linkLabel }}
            </template>
        </a>

        <div v-else-if="isEditing" class="grid grid-cols-2 gap-4">
            <div>
                <label class="flex justify-between items-center mb-1.5 text-sm">
                    Link text
                </label>
                <input
                    type="text"
                    v-model="linkLabel"
                    class="block w-full text-sm rounded border-gray-300 focus:border-gray-400 focus:ring-0"
                />
            </div>

            <div>
                <label class="flex justify-between items-center mb-1.5 text-sm">
                    URL
                </label>
                <input
                    type="text"
                    v-model="linkRoute"
                    placeholder="https://"
                    class="block w-full text-sm rounded border-gray-300 focus:border-gray-400 focus:ring-0"
                />
            </div>
        </div>
    </div>
</template>
